import { RegisterExpressionRule } from "./RegisterExpressionRule";

import { AbsoluteExpression } from "./Expressions/Math/AbsoluteExpression";
import { DateEqualToExpression } from "./Expressions/Date/DateEqualToExpression";
import { DateGetDayExpression } from "./Expressions/Date/DateGetDayExpression";
import { DateGetHourExpression } from "./Expressions/Date/DateGetHourExpression";
import { DateGetMinuteExpression } from "./Expressions/Date/DateGetMinuteExpression";
import { DateGetMonthExpression } from "./Expressions/Date/DateGetMonthExpression";
import { DateGetSecondExpression } from "./Expressions/Date/DateGetSecondExpression";
import { DateGetTodayExpression } from "./Expressions/Date/DateGetTodayExpression";
import { DateGetYearExpression } from "./Expressions/Date/DateGetYearExpression";
import { DateGreaterThanExpression } from "./Expressions/Date/DateGreaterThanExpression";
import { DateLessThanExpression } from "./Expressions/Date/DateLessThanExpression";
import { ExistsExpression } from "./Expressions/Logic/Exists";
import { GreaterThanExpression } from "./Expressions/Logic/GreaterThan";
import { LessThanExpression } from "./Expressions/Logic/LessThanExpression";
import { StringIndexOfExpression } from "./Expressions/String/StringIndexOfExpression";
import { StringListInExpression } from "./Expressions/String/StringListInExpression";
import { StringListContainsExpression } from "./Expressions/String/StringListContainsExpression";
import { StringStartWithExpression } from "./Expressions/String/StringStartWithExpression";
import { MaxExpression } from "./Expressions/Math/MaxExpression";
import { StringTrimExpression } from "./Expressions/String/StringTrimExpression";
import { StringUppercaseExpression } from "./Expressions/String/StringUppercaseExpression";
import { EqualExpression } from "./Expressions/Math/EqualExpression";
import { ModExpression } from "./Expressions/Math/ModExpression";
import { NotExpression } from "./Expressions/Logic/NotExpression";
import { StringLowercaseExpression } from "./Expressions/String/StringLowercaseExpression";
import { StringNotContainsExpression } from "./Expressions/String/StringNotContainsExpression";
import { AndGroup } from "./Expressions/Logic/AndGroup";
import { GreaterThanEqualToExpression } from "./Expressions/Logic/GreaterThanEqualTo";
import { NotEqualExpression } from "./Expressions/Math/NotEqualExpression";
import { RandomExpression } from "./Expressions/Math/RandomExpression";
import { StringListNotAllInExpression } from "./Expressions/String/StringListNotAllInExpression";
import { StringListAllInExpression } from "./Expressions/String/StringListAllInExpression";
import { StringLengthExpression } from "./Expressions/String/StringLengthExpression";
import { StringContainsExpression } from "./Expressions/String/StringContainsExpression";
import { StringEqualExpression } from "./Expressions/String/StringEqualExpression";
import { StringEndWithExpression } from "./Expressions/String/StringEndWithExpression";
import { StringListGetStringByIndexExpression } from "./Expressions/String/StringListGetStringByIndexExpression";
import { AsPercentageExpression } from "./Expressions/Math/AsPercentageExpression";
import { StringIsNotEmptyExpression } from "./Expressions/String/StringIsNotEmptyExpression";
import { StringIsEmptyExpression } from "./Expressions/String/StringIsEmptyExpression";
import { StringListCombineExpression } from "./Expressions/String/StringListCombineExpression";
import { IfThenExpression } from "./Expressions/Logic/IfThenExpression";
import { StringIsValidEmailExpression } from "./Expressions/String/StringIsValidEmailExpression";
import { MultiplyExpression } from "./Expressions/Math/MultiplyExpression";
import { IsFalseExpression } from "./Expressions/Logic/IsFalse";
import { RoundExpression } from "./Expressions/Math/RoundExpression";
import { LessThanEqualToExpression } from "./Expressions/Logic/LessThanEqualToExpression";
import { AverageExpression } from "./Expressions/Math/AverageExpression";
import { StringListNotContainsExpression } from "./Expressions/String/StringListNotContainsExpression";
import { IsTrueExpression } from "./Expressions/Logic/IsTrue";
import { StringProperExpression } from "./Expressions/String/StringProperExpression";
import { MinExpression } from "./Expressions/Math/MinExpression";
import { DivideExpression } from "./Expressions/Math/DivideExpression";
import { StringCombineExpression } from "./Expressions/String/StringCombineExpression";
import { AddExpression } from "./Expressions/Math/AddExpression";
import { StringListNotInExpression } from "./Expressions/String/StringListNotInExpression";
import { SubstractExpression } from "./Expressions/Math/SubstractExpression";
import { AsCurrencyExpression } from "./Expressions/Math/AsCurrencyExpression";
import { SumExpression } from "./Expressions/Math/SumExpression";
import { OrGroup } from "./Expressions/Logic/OrGroup";
import { RootExpression } from "./RootExpression";
import { NumberDataDefinition } from "../Common/Data/Definitions/NumberDataDefinition";
import { BooleanDataDefinition } from "../Common/Data/Definitions/BooleanDataDefinition";
import { StringDataDefinition } from "../Common/Data/Definitions/StringDataDefinition";
import { DateDataDefinition } from "../Common/Data/Definitions/DateDataDefinition";
import { DateAddXExpression } from "./Expressions/Date/DateAddXExpression";
import { DateNowExpression } from "./Expressions/Date/DateNowExpression";
import { DateSubtractXExpression } from "./Expressions/Date/DateSubtractXExpression";

// -------------
// this is the registration of all default expression elements
// -------------
export class RegisterExpressionRules {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterExpressionRules.isRegistered) return;

        RegisterExpressionRules.isRegistered = true;

        RegisterExpressionRule(new RootExpression(), "Logic", new NumberDataDefinition(), false, () => false);

        RegisterExpressionRule(new AbsoluteExpression(), "Math", new NumberDataDefinition());

        RegisterExpressionRule(new DateEqualToExpression(), "Date", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new DateGetDayExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGetHourExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGetMinuteExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGetMonthExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGetSecondExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGetTodayExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGetYearExpression(), "Date", new NumberDataDefinition());
        RegisterExpressionRule(new DateGreaterThanExpression(), "Date", new BooleanDataDefinition());
        RegisterExpressionRule(new DateLessThanExpression(), "Date", new BooleanDataDefinition());
        RegisterExpressionRule(new DateAddXExpression(), "Date", new DateDataDefinition());
        RegisterExpressionRule(new DateNowExpression(), "Date", new DateDataDefinition());
        RegisterExpressionRule(new DateSubtractXExpression(), "Date", new DateDataDefinition());

        RegisterExpressionRule(new ExistsExpression(), "Logic", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new GreaterThanExpression(), "Math", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new GreaterThanEqualToExpression(), "Math", new BooleanDataDefinition());
        RegisterExpressionRule(new AndGroup(), "Logic", new BooleanDataDefinition());
        RegisterExpressionRule(new OrGroup(), "Logic", new BooleanDataDefinition(), false);
        RegisterExpressionRule(new IfThenExpression(), "Logic", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new IsFalseExpression(), "Logic", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new IsTrueExpression(), "Logic", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new LessThanExpression(), "Math", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new LessThanEqualToExpression(), "Math", new BooleanDataDefinition());
        RegisterExpressionRule(new NotExpression(), "Logic", new BooleanDataDefinition(), true);

        RegisterExpressionRule(new AddExpression(), "Math", new NumberDataDefinition(), true);
        RegisterExpressionRule(new AsCurrencyExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new AsPercentageExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new AverageExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new DivideExpression(), "Math", new NumberDataDefinition(), true);
        RegisterExpressionRule(new EqualExpression(), "Math", new NumberDataDefinition(), true);
        RegisterExpressionRule(new MaxExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new MinExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new ModExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new MultiplyExpression(), "Math", new NumberDataDefinition(), true);
        RegisterExpressionRule(new SubstractExpression(), "Math", new NumberDataDefinition(), true);
        RegisterExpressionRule(new SumExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new NotEqualExpression(), "Math", new NumberDataDefinition());
        RegisterExpressionRule(new RandomExpression(), "Math", new NumberDataDefinition(), false);
        RegisterExpressionRule(new RoundExpression(), "Math", new NumberDataDefinition());

        RegisterExpressionRule(new StringCombineExpression(), "Text", new StringDataDefinition());
        RegisterExpressionRule(new StringContainsExpression(), "Text", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new StringEqualExpression(), "Text", new BooleanDataDefinition(), true);
        RegisterExpressionRule(new StringEndWithExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringIndexOfExpression(), "Text", new NumberDataDefinition());
        RegisterExpressionRule(new StringIsEmptyExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringIsNotEmptyExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringIsNotEmptyExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringIsValidEmailExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringLengthExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringLowercaseExpression(), "Text", new StringDataDefinition());
        RegisterExpressionRule(new StringNotContainsExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringProperExpression(), "Text", new StringDataDefinition());
        RegisterExpressionRule(new StringStartWithExpression(), "Text", new BooleanDataDefinition());
        RegisterExpressionRule(new StringTrimExpression(), "Text", new StringDataDefinition());
        RegisterExpressionRule(new StringUppercaseExpression(), "Text", new StringDataDefinition());

        let stringlistdd = new StringDataDefinition();
        stringlistdd.list = true;

        RegisterExpressionRule(new StringListCombineExpression(), "Text [List]", stringlistdd);
        RegisterExpressionRule(new StringListContainsExpression(), "Text [List]", new StringDataDefinition());
        RegisterExpressionRule(new StringListGetStringByIndexExpression(), "Text [List]", new StringDataDefinition());
        RegisterExpressionRule(new StringListInExpression(), "Text [List]", new BooleanDataDefinition());
        RegisterExpressionRule(new StringListNotAllInExpression(), "Text [List]", new BooleanDataDefinition());
        RegisterExpressionRule(new StringListNotContainsExpression(), "Text [List]", new StringDataDefinition());
        RegisterExpressionRule(new StringListNotInExpression(), "Text [List]", new BooleanDataDefinition());
        RegisterExpressionRule(new StringListAllInExpression(), "Text [List]", new BooleanDataDefinition());
    }
}
